import React from "react";
import { FaImdb, FaLinkedinIn } from "react-icons/fa";
import { Link as LinkRoll } from 'react-scroll'
import "./Hero2.css";

const Hero2 = () => {
  return (
    <section className="hero" id="home">

      {/* Brand */}
      <div className="hero-brand">
        <div className="brand-logo">
          <span>A</span>
          <span>F</span>
        </div>

        <span className="brand-name">
          Alwyn Funa
        </span>
      </div>


      {/* Desktop Navigation */}
      <nav className="hero-nav">

        <a href="#home" className="active">
          Home
        </a>

        <LinkRoll activeClass="active" to="aboutMe" spy={true} smooth={true} duration={500} >
        <a>ABOUT ME</a>
        </LinkRoll>

        <LinkRoll activeClass="active" to="myWork" spy={true} smooth={true} duration={500} >
        <a>MY WORK</a>
        </LinkRoll>

        <LinkRoll activeClass="active" to="Software" spy={true} smooth={true} duration={500} >
        <a>SOFTWARE</a>
        </LinkRoll>

        <LinkRoll activeClass="active" to="Contact" spy={true} smooth={true} duration={500} >
        <a>CONTACT</a>
        </LinkRoll>

      </nav>


      {/* Top Right CTA */}
    <LinkRoll activeClass="active" to="Contact" spy={true} smooth={true} duration={500} >

      <a
        href="#contact"
        className="hero-create-btn"
      >
        Let's Create
      </a>
    </LinkRoll>

      {/* Decorative Left Text */}
      <div className="hero-side-copy">

        <span>Ideas</span>
        <span>In</span>
        <span>Motion</span>

        <div className="side-line"></div>

      </div>


      {/* Hero Content */}
      <div className="hero-content">

        <h1>
          Alwyn Funa
        </h1>

        <h2>
          Animator and Graphic Designer
        </h2>

        <p className="hero-description">
          Bringing ideas to life through motion,
          design, and creative storytelling.
        </p>


        {/* CTA Buttons */}
        <div className="hero-buttons">
        <LinkRoll activeClass="active" to="myWork" spy={true} smooth={true} duration={500} >

          <a
            href="#work"
            className="hero-button hero-button-primary"
          >
            View My Work

            <span className="button-arrow">
              →
            </span>
          </a>
          </LinkRoll>


        <LinkRoll activeClass="active" to="Contact" spy={true} smooth={true} duration={500} >

          <a
            href="#contact"
            className="hero-button hero-button-outline"
          >
            Get In Touch
          </a>
        </LinkRoll>

        </div>


        {/* Social Links */}
        <div className="hero-socials">

          <a
            href="https://www.linkedin.com/in/alwyn-funa/"
            target="_blank"
            rel="noreferrer"
            aria-label="Alwyn Funa LinkedIn"
          >
            <FaLinkedinIn />
          </a>

          <a
            href="https://www.imdb.com/name/nm3215245/"
            target="_blank"
            rel="noreferrer"
            aria-label="Alwyn Funa IMDb"
          >
            <FaImdb />
          </a>

        </div>

      </div>


      {/* Decorative Large AF */}
      <div
        className="hero-watermark"
        aria-hidden="true"
      >
        AF
      </div>


      {/* Bottom Right Copy */}
      <div className="hero-creative-text">

        <span>Create</span>
        <span>Design</span>
        <span>Animate</span>
        <span>Inspire</span>

      </div>


      {/* Scroll Indicator */}
    <LinkRoll activeClass="active" to="myWork" spy={true} smooth={true} duration={500} >

      <a
        href="#about"
        className="hero-scroll"
        aria-label="Scroll to About section"
      >
        <span className="scroll-label">
          Scroll
        </span>

        <div className="scroll-mouse">
          <span></span>
        </div>
      </a>
      </LinkRoll>

    </section>
  );
};

export default Hero2;